import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import Dropzone from 'react-dropzone';
import { Modal } from 'react-bootstrap';
import { Dropdown } from '../../components/Dropdown/Dropdown';
import Input from 'components/react-validation/components/input';
import * as Vali from 'helper/validator-helper';
import { decimalFixed } from 'helper/unit-helper';
import Form from 'components/react-validation/components/form';
import Textarea from '../../components/react-validation/components/text-area';
import Submit from '../../components/react-validation/components/submit';
import * as CostCodeActionTypes from '../../CostCodes/constants';
import * as WorkOrderActionType from '../../Work-Orders/constants';
import * as PurchaseOrderActionType from '../../Purchase-Orders/constants';
import PubSub from 'services/pubsub-service';
import * as PubSubActionType from 'services/constants';
import { print } from '../../helper/unit-helper';
import BackChargeList from '../../Work-Orders/Components/BackChargeList';
import Translate from 'components/translate';
import { AppSettings } from '../../constants';
import {isMobile} from 'react-device-detect';
import PreviewVideoWO from '../../Work-Orders/Components/PreviewVideoWO';
import { PreviewImage } from 'components/PreviewImage';
class PurchaseOrderDetail extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    costCodeSelectList: PropTypes.array,
    userProfile: PropTypes.object,
    workOrderProfile: PropTypes.object,
    PurchaseOrderProfile: PropTypes.object,
    location: PropTypes.string,
    WorkOrderCredentials: PropTypes.any,
    history: PropTypes.func
  };

  constructor(props) {
    super(props);

    let rfsId = null;
    let workOrderId = null;
    let purchaseOrderId = null;
    let isEditPurchaseOrder = false;

    if (!isEmpty(props.location.search)) {
      const arraySearch = props.location.search.replace('?', '').split('=', 2);
      if (arraySearch[0] === 'isEdit' && arraySearch[1] === 'true') {
        isEditPurchaseOrder = true;
      }
    }

    if (props.match.params.RFSID) {
      rfsId = props.match.params.RFSID;
    }

    if (props.match.params.WOID) {
      workOrderId = props.match.params.WOID;
    }

    if (props.match.params.POID) {
      purchaseOrderId = props.match.params.POID;
    }

    this.state = {
      rfsId: rfsId,
      workOrderId: workOrderId,
      purchaseOrderId: purchaseOrderId,
      isLoadingGetCostCodeSelectList: false,
      isEditPurchaseOrder,
      files: [],
      showDialog: false,
      videoUrl: null
    };
  }

  componentDidMount() {
    this.fetchPurchaseOrderDetail();
    this.fetchCostCodeSelectList();
    document.addEventListener('mousedown', this.handleHideEmbedPreview);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleHideEmbedPreview);
  }

  fetchPurchaseOrderDetail = () => {
    if (AppSettings.clientTypeValue === 'Subcontractor') {
      this.props.dispatch({
        type:
          PurchaseOrderActionType.GET_SUBCONTRACTOR_PURCHASE_ORDER_DETAIL_ASYNC,
        params: {
          rfsRefNo: this.state.rfsId,
          WOID: this.state.workOrderId,
          refNo: this.state.purchaseOrderId
        }
      });
    } else {
      this.props.dispatch({
        type: PurchaseOrderActionType.GET_PURCHASE_ORDER_DETAIL_ASYNC,
        params: {
          rfsRefNo: this.state.rfsId,
          WOID: this.state.workOrderId,
          refNo: this.state.purchaseOrderId
        }
      });
    }
  };

  fetchCostCodeSelectList = () => {
    this.setState({ isLoadingGetCostCodeSelectList: true });
    this.props.dispatch({
      type: CostCodeActionTypes.GET_COST_CODE_SELECT_LIST_ASYNC,
      callback: () => this.setState({ isLoadingGetCostCodeSelectList: false })
    });
  };

  resendPO = () => {
    const { purchaseOrderId, rfsId } = this.state;

    this.props.dispatch({
      type: PurchaseOrderActionType.RESEND_PO_ASYNC,
      params: {
        refNo: purchaseOrderId,
        rfsId
      }
    });
  };

  handleCancel = () => {
    this.setState({
      isEditPurchaseOrder: false,
      isDeleteAttachment: false,
      costCode: {
        value: this.props.PurchaseOrderProfile.costCodeInfo.id,
        text: this.props.PurchaseOrderProfile.costCodeInfo.name,
        extensionValue: {
          code: this.props.PurchaseOrderProfile.costCodeInfo.code,
          name: this.props.PurchaseOrderProfile.costCodeInfo.name
        },
        selected: false
      }
    });
  };

  onSelectChange = (event, name) => {
    this.setState({ [name]: event.value });
  };

  hideLoading = () => {
    setTimeout(() => {
      PubSub.publish(PubSubActionType.LOADING_INDICATOR, {
        isHideIndicator: true
      });
    }, 500);
  };

  onSubmit = e => {
    e.preventDefault();
    PubSub.publish(PubSubActionType.LOADING_INDICATOR, {
      isHideIndicator: false
    });
    let isUploadAttachment = false;
    const { PurchaseOrderProfile } = this.props;
    const formData = this.form.getValues();
    if (!isEmpty(this.state.files)) {
      isUploadAttachment = true;
    }
    formData.costCode = this.state.costCode
      ? this.state.costCode.value
      : PurchaseOrderProfile.costCodeInfo.id;
    formData.estimatedAmount = decimalFixed(formData.estimatedAmount);
    formData.actualAmount = decimalFixed(formData.actualAmount);

    if (
      PurchaseOrderProfile.attachments &&
      PurchaseOrderProfile.attachments.length &&
      !this.state.isDeleteAttachment
    ) {
      formData.key = PurchaseOrderProfile.attachments[0].key;
      formData.fileName = PurchaseOrderProfile.attachments[0].fileName;
      formData.url = PurchaseOrderProfile.attachments[0].url;
    }
    this.props.dispatch({
      type: PurchaseOrderActionType.EDIT_PURCHASE_ORDER_ASYNC,
      params: {
        refNo: PurchaseOrderProfile.refNo,
        data: formData,
        isUploadAttachment,
        rfsId: this.state.rfsId
      },
      callback: (data, status) => {
        if (!isEmpty(this.state.files)) {
          this.setupAWS({ refNo: PurchaseOrderProfile.refNo });
        } else {
          if (status === false) {
            this.hideLoading();
          } else {
            this.hideLoading();
            this.setState({ isEditPurchaseOrder: false });
          }
        }
      }
    });
  };
  setupAWS = data => {
    this.props.dispatch({
      type: WorkOrderActionType.SETUP_AWS_S3_ASYNC,
      params: { resourcePath: `purchase-order/${data.refNo}` },
      callback: () => {
        this.state.files.map(file => {
          this.props.dispatch({
            type: WorkOrderActionType.UPLOAD_FILE_WORK_ORDER_ASYNC,
            params: {
              refNo: data.refNo,
              config: this.props.WorkOrderCredentials,
              file: file
            },
            callback: this.onUploadFileCallback(file.name)
          });
        });
      }
    });
  };

  onUploadFileCallback = fileName => (status, data) => {
    if (data.refNo) {
      this.uploadAttachmentsToServer(data, fileName);
    }
  };

  uploadAttachmentsToServer = (data, fileName) => {
    this.props.dispatch({
      type: PurchaseOrderActionType.PURCHASE_ORDER_ATTACHMENTS_ASYNC,
      params: {
        refNo: data.refNo,
        data: {
          url: data.data.Location,
          key: data.data.Key,
          fileName: fileName
        },
        rfsId: this.state.rfsId
      },
      callback: () => {
        this.hideLoading();
        this.setState(
          { isEditPurchaseOrder: false, files: [], isDeleteAttachment: false },
          () => {
            this.fetchPurchaseOrderDetail();
          }
        );
      }
    });
  };

  onDrop = e => {
    let newFiles = this.state.files;
    e.map(file => {
      file.uploadId = _.uniqueId();
      newFiles.push(file);
      this.setState({
        files: newFiles
      });
    });
  };

  deleteFile = index => {
    const files = this.state.files;
    files.splice(index, 1);
    this.setState({ files });
  };

  deleteAttachment = () => {
    this.setState({ isDeleteAttachment: true });
  };

  renderAttchment(PurchaseOrderProfile) {
    return (
      <div className='row col-sm-12'>
        <label>Attachment</label>
        <div>
          <Dropzone
            disableClick
            multiple={false}
            ref={node => {
              this.dropzoneRef = node;
            }}
            onDrop={this.onDrop}
            accept={['image/*', 'application/pdf']}
            style={{ position: 'initial' }}
          >
            {this.state.files.map((item, index) => (
              <div className='file-item' key={index}>
                <div>
                  <p className='item-name'>
                    {item.name} &nbsp;{' '}
                    <i
                      className='fa fa-trash ic-stop'
                      onClick={() => this.deleteFile(index)}
                    />
                  </p>
                </div>
              </div>
            ))}
            {!isEmpty(PurchaseOrderProfile.attachments) &&
              !this.state.isDeleteAttachment &&
              map(PurchaseOrderProfile.attachments, (item, index) => (
                <div className='file-item' key={index}>
                  <div>
                    <p className='item-name'>
                      {item.fileName} &nbsp;{' '}
                      <i
                        className='fa fa-trash ic-stop'
                        onClick={() => this.deleteAttachment()}
                      />
                    </p>
                  </div>
                </div>
              ))}
            {((isEmpty(this.state.files) &&
              isEmpty(PurchaseOrderProfile.attachments)) ||
              (this.state.isDeleteAttachment && isEmpty(this.state.files))) && (
                <div className='files-bottom row col-xs-12'>
                  <p>
                    <a
                      className='files-browse-txt cursor-pointer'
                      onClick={() => {
                        this.dropzoneRef.open();
                      }}
                    >
                      {' '}
                    + Add new attachment.
                    </a>
                  </p>
                </div>
              )}
          </Dropzone>
        </div>
      </div>
    );
  }

  costCodeItemTemplate = option => {
    if (!option.value) {
      return option.text;
    }
    return (
      <div className='ui-helper-clearfix'>
        <span>
          {option.extensionValue.name} ({option.extensionValue.code})
        </span>
      </div>
    );
  };

  costCodelabelTemplate = option => {
    return (
      <span>
        {option.extensionValue.name} ({option.extensionValue.code})
      </span>
    );
  };

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  getCostCodeOptions = () => {
    const { PurchaseOrderProfile, costCodeSelectList } = this.props;

    const { costCode } = this.state;

    if (costCodeSelectList.length) {
      if (costCode) {
        const optionFound = costCodeSelectList.find(
          item => item.value === costCode.value
        );
        if (!optionFound) {
          //current cost code is inactive
          return [...costCodeSelectList, { ...costCode, except: true }];
        } else {
          return costCodeSelectList;
        }
      } else {
        const optionFound = costCodeSelectList.find(
          item => item.value === PurchaseOrderProfile.costCodeInfo.id
        );
        if (!optionFound) {
          //current cost code is inactive
          return [
            ...costCodeSelectList,
            {
              value: PurchaseOrderProfile.costCodeInfo.id,
              text: PurchaseOrderProfile.costCodeInfo.name,
              extensionValue: {
                code: PurchaseOrderProfile.costCodeInfo.code,
                name: PurchaseOrderProfile.costCodeInfo.name
              },
              selected: false,
              except: true
            }
          ];
        } else {
          return costCodeSelectList;
        }
      }
    } else {
      return [
        {
          value: PurchaseOrderProfile.costCodeInfo.id,
          text: PurchaseOrderProfile.costCodeInfo.name,
          extensionValue: {
            code: PurchaseOrderProfile.costCodeInfo.code,
            name: PurchaseOrderProfile.costCodeInfo.name
          },
          selected: false
        }
      ];
    }
  };

  renderEditPurchaseOrder() {
    const { PurchaseOrderProfile } = this.props;
    if (isEmpty(PurchaseOrderProfile)) {
      return null;
    }
    let {
      projectCode,
      estimatedAmount,
      actualAmount,
      reason,
      instruction,
      subcontractorInvoiceNumber
    } = PurchaseOrderProfile;
    if (this.form) {
      projectCode = this.form.getValues().projectCode;
      estimatedAmount = this.form.getValues().estimatedAmount;
      actualAmount = this.form.getValues().actualAmount;
      reason = this.form.getValues().reason;
      instruction = this.form.getValues().instruction;
      subcontractorInvoiceNumber = this.form.getValues()
        .subcontractorInvoiceNumber;
    }

    const costCodeOptions = this.getCostCodeOptions();

    return (
      <div className='subcontractor box-form-siteone'>
        <div className='box-form-body'>
          <Form
            ref={ref => {
              this.form = ref;
            }}
            onSubmit={this.onSubmit}
          >
            <div className='row'>
              <div className='col-sm-4 col-xs-6'>
                <div className='form-group'>
                  <label>
                    Cost center/account
                    <span className='text-danger'> *</span>
                  </label>
                  <Input
                    onKeyPress={this.handleKeyPress}
                    type='text'
                    name='projectCode'
                    ref='projectCode'
                    placeholder='Type in cost centers/accounts'
                    className='form-control'
                    value={projectCode}
                    max='100'
                    maxLength='100'
                    errorMsg='Summary is maximum 100 characters'
                    validations={[Vali.required, Vali.maxlength]}
                  />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-4 col-xs-6'>
                <div className='form-group'>
                  <label>
                    Cost code <span className='text-danger'> *</span>
                  </label>
                  <Dropdown
                    onChange={ref => {
                      this.onSelectChange(ref, 'costCode');
                    }}
                    className='filestring-dropdown filter-dropdown'
                    onRemote={this.fetchCostCodeSelectList}
                    options={costCodeOptions}
                    loading={this.state.isLoadingGetCostCodeSelectList}
                    optionLabel='text'
                    value={
                      this.state.costCode || {
                        value: PurchaseOrderProfile.costCodeInfo.id,
                        text: '',
                        extensionValue: {
                          code: PurchaseOrderProfile.costCodeInfo.code,
                          name: PurchaseOrderProfile.costCodeInfo.name
                        },
                        selected: false
                      }
                    }
                    itemTemplate={this.costCodeItemTemplate}
                    labelTemplate={this.costCodelabelTemplate}
                    showClear={false}
                    name='workOrderType'
                    placeholder='--Please select'
                    style={{ width: '100%', position: 'relative' }}
                  />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-12'>
                <div className='form-group row'>
                  <div className='col-lg-2 col-sm-4'>Issued to</div>
                  <div className='col-lg-10 col-sm-8'>
                    <strong>
                      {PurchaseOrderProfile.subcontractor.companyName}
                    </strong>
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-6'>
                <div className='row'>
                  <div className='col-sm-8'>
                    <div className='form-group'>
                      <label>
                        Estimated amount<span className='text-danger'> *</span>
                      </label>
                      <div style={{ position: 'relative' }}>
                        <span className='addon-input'>$</span>
                        <Input
                          onKeyPress={this.handleKeyPress}
                          style={{ paddingLeft: 20 }}
                          type='text'
                          value={estimatedAmount.toString()}
                          name='estimatedAmount'
                          ref='estimatedAmount'
                          className='form-control'
                          max='12'
                          maxLength='12'
                          errorMsg='Estimated amount is maximum 12 characters'
                          validations={[
                            Vali.required,
                            Vali.maxlength,
                            Vali.isNumber
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-sm-6'>
                <div className='row'>
                  <div className='col-sm-8'>
                    <div className='form-group'>
                      <label>Actual amount</label>
                      <div style={{ position: 'relative' }}>
                        <span className='addon-input'>$</span>
                        <Input
                          type='text'
                          name='actualAmount'
                          ref='actualAmount'
                          defaultValue='0'
                          isUsed
                          className='form-control'
                          maxLength='12'
                          max='12'
                          compare='estimatedAmount'
                          compareType='bigger'
                          compareErrorMsg='Estimated amount should be equal or greater than Actual amount.'
                          errorMsg='Actual amount is maximum 12 characters'
                          validations={[
                            Vali.maxlength,
                            Vali.compare,
                            Vali.isNumber
                          ]}
                          onKeyPress={this.handleKeyPress}
                          style={{ paddingLeft: 20 }}
                          value={
                            actualAmount || actualAmount === 0
                              ? actualAmount.toString()
                              : ''
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-10'>
                <div className='form-group'>
                  <label>Reason for issuing PO</label>
                  <Textarea
                    className='form-control'
                    name='reason'
                    ref='reason'
                    max='500'
                    maxLength='500'
                    errorMsg='Reson for issuing PO is maximum 500 characters'
                    style={{ height: 100 }}
                    value={reason}
                    validations={[Vali.maxlength]}
                  />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-10'>
                <div className='form-group'>
                  <label>
                    Instruction<span className='text-danger'> *</span>
                  </label>
                  <Textarea
                    className='form-control'
                    name='instruction'
                    ref='instruction'
                    max='1000'
                    maxLength='1000'
                    errorMsg='Instruction is maximum 1000 characters'
                    style={{ height: 200 }}
                    value={instruction}
                    validations={[Vali.required, Vali.maxlength]}
                  />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-6'>
                <div className='form-group row'>
                  <div className='edit-po-label-inline'>Issued date</div>
                  <div className='edit-po-value-inline'>
                    <strong>
                      {moment(PurchaseOrderProfile.issuedDate).format(
                        'MM/DD/YYYY'
                      )}
                    </strong>
                  </div>
                </div>
              </div>

              <div className='col-sm-6'>
                <div className='form-group row'>
                  <div className='edit-po-label-inline'>Issued by</div>
                  <div className='edit-po-value-inline'>
                    <strong>
                      {PurchaseOrderProfile.issuedByUser.displayName}
                    </strong>
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-4 col-xs-6'>
                <div className='form-group'>
                  <label>Subcontractor invoice number</label>
                  <Input
                    onKeyPress={this.handleKeyPress}
                    type='text'
                    name='subcontractorInvoiceNumber'
                    ref='subcontractorInvoiceNumber'
                    className='form-control'
                    max='100'
                    maxLength='100'
                    value={subcontractorInvoiceNumber}
                    errorMsg='Subcontractor invoice number is maximum 100 characters'
                    validations={[Vali.maxlength]}
                  />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12'>
                <div className='form-group'>
                  {this.renderAttchment(PurchaseOrderProfile)}
                </div>
              </div>
            </div>

            <div className='form-group' style={{ marginTop: 15 }}>
              <a
                className='btn btn-primary btn-siteone-default'
                onClick={this.handleCancel}
              >
                Cancel
              </a>
              <Submit className='btn btn-primary btn-submit btn-siteone'>
                Save
              </Submit>
            </div>
          </Form>
        </div>
      </div>
    );
  }

  onClickEditButton = () => {
    this.setState({ isEditPurchaseOrder: true });
  };

  renderPurchaseOrderInfoValue(value, isMoney) {
    if (isMoney) {
      if (value === null || value === 'null') {
        return <span style={{ opacity: 0.5 }}>(Not specified)</span>;
      }
      return <strong>{Number(value).toFixed(2)}</strong>;
    }

    if (value) {
      return <strong style={{ wordBreak: 'break-all' }}>{value}</strong>;
    }

    return <span style={{ opacity: 0.5 }}>(Not specified)</span>;
  }

  renderResendPO() {
    if (AppSettings.clientTypeValue === 'Builder') {
      return (
        <a href='#' onClick={this.resendPO} style={{ marginLeft: 20 }}>
          {' '}
          Resend PO
        </a>
      );
    }

    return null;
  }

  handleShow = url => {
    const imageType = ['jpg', 'jpeg', 'png', 'gif'];
    const extension = url.split('.').pop().toLowerCase();
    const videoType = ['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'];
    if (
      imageType.includes(
        extension
      )
    ) {
      this.setState({
        show: true,
        previewUrl: url
      });
    }
    if (
      extension === 'pdf'
    ) {
      this.setState({
        isPreviewPDF: url
      }, () => {
        if (isMobile) {
          window.open(this.state.isPreviewPDF, '_blank');
        }
      });
    }
    if (
      videoType.includes(
        extension
      )
    ) {
      this.setState({
        showDialog: true,
        videoUrl: url
      });
    }
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  handleCloseVideo = () => {
    this.setState({
      showDialog: false,
      videoUrl: null
    });
  }

  handleHideEmbedPreview = event => {
    if (this.embedPreview && !this.embedPreview.contains(event.target)) {
      this.setState({
        isPreviewPDF: null
      });
    }
  };

  renderPurchaseOrderInfo() {
    const { PurchaseOrderProfile } = this.props;
    if (isEmpty(PurchaseOrderProfile)) {
      return null;
    }
    return (
      <div
        className='box-form-siteone col-xs-12 col-lg-12 add-wo-form'
        style={{ paddingTop: 20 }}
      >
        <div className='row col-sm-12 form-group'>
          <label className='col-sm-3 control-label'>
            Cost center/account
          </label>
          <div className='col-sm-9' style={{ padding: '0 15px' }}>
            {this.renderPurchaseOrderInfoValue(
              PurchaseOrderProfile.projectCode
            )}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-sm-3 control-label'>Cost code</label>
          <div className='col-sm-9' style={{ padding: '0 15px' }}>
            {PurchaseOrderProfile.costCodeInfo ? (
              <span>{`${PurchaseOrderProfile.costCodeInfo.name} (${
                PurchaseOrderProfile.costCodeInfo.code
              })`}</span>
            ) : (
              <span style={{ opacity: 0.5 }}>(Not specified)</span>
            )}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-sm-3 control-label'>Issued to</label>
          <div className='col-sm-9' style={{ padding: '0 15px' }}>
            {this.renderPurchaseOrderInfoValue(
              PurchaseOrderProfile.subcontractor.companyName
            )}{' '}
            {this.renderResendPO()}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-sm-3 control-label'>Estimated amount</label>
          <div className='col-sm-9' style={{ padding: '0 15px' }}>
            ${' '}
            {this.renderPurchaseOrderInfoValue(
              PurchaseOrderProfile.estimatedAmount,
              true
            )}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-sm-3 control-label'>Actual amount</label>
          <div className='col-sm-9' style={{ padding: '0 15px' }}>
            ${' '}
            {this.renderPurchaseOrderInfoValue(
              PurchaseOrderProfile.actualAmount,
              true
            )}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-sm-3 control-label'>
            Reason for issuing PO
          </label>
          <div className='col-sm-9' style={{ padding: '0 15px' }}>
            {this.renderPurchaseOrderInfoValue(PurchaseOrderProfile.reason)}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-sm-3 control-label'>Instruction</label>
          <div className='col-sm-9' style={{ padding: '0 15px' }}>
            {this.renderPurchaseOrderInfoValue(
              PurchaseOrderProfile.instruction
            )}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-sm-3 control-label'>Issued date</label>
          <div className='col-sm-9' style={{ padding: '0 15px' }}>
            {this.renderPurchaseOrderInfoValue(
              moment(PurchaseOrderProfile.issuedDate).format('MM/DD/YYYY')
            )}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-sm-3 control-label'>Issued by</label>
          <div className='col-sm-9' style={{ padding: '0 15px' }}>
            {PurchaseOrderProfile.issuedByUser ? (
              this.renderPurchaseOrderInfoValue(
                PurchaseOrderProfile.issuedByUser.displayName
              )
            ) : (
              <span style={{ opacity: 0.5 }}>(Not specified)</span>
            )}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-sm-3 control-label'>
            Subcontractor invoice number
          </label>
          <div className='col-sm-9' style={{ padding: '0 15px' }}>
            {this.renderPurchaseOrderInfoValue(
              PurchaseOrderProfile.subcontractorInvoiceNumber
            )}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-sm-3 control-label'>Attachment</label>
          <div className='col-sm-9' style={{ padding: '0 15px' }}>
            {map(PurchaseOrderProfile.attachments, (item, index) => {
              return (
                <span
                  className='attachment-item'
                  onClick={() => this.handleShow(item.url)}
                  key={index}
                >
                  {item.fileName}
                </span>
              );
            })}
          </div>
        </div>
        {AppSettings.clientTypeValue === 'Builder' && (
          <div className='col-sm-12 form-group'>
            <button
              className='btn btn-primary btn-siteone-default'
              onClick={this.onClickEditButton}
            >
              Edit
            </button>
          </div>
        )}
      </div>
    );
  }

  printPreviewPurchaseOrder = () => {
    this.props.dispatch({
      type: WorkOrderActionType.PRINT_PREVIEW_PURCHASE_ORDER_ASYNC,
      params: {
        refNo: this.state.purchaseOrderId
      },
      callback: (status, content) => {
        if (status) {
          print(content);
        }
      }
    });
  };

  render() {
    const {previewUrl, isPreviewPDF, showDialog, show, videoUrl, purchaseOrderId, isEditPurchaseOrder, rfsId, workOrderId} = this.state;
    return (
      <div className='rfs-detail add-new-work-order'>
        <div className='page-title clearfix'>
          <div>
            <h2 className='pull-left'>PO #{purchaseOrderId}</h2>
          </div>
          <div>
            <div className='text-right print-icon'>
              <i
                onClick={this.printPreviewPurchaseOrder}
                className='glyphicon glyphicon-print'
              />
            </div>
          </div>
        </div>
        <ul className='breadcrumb'>
          <li>
            <Link to={'/punch-lists'}><Translate translateKey='punchlist' capitalize/></Link>
          </li>
          <li>
            <Link to={`/punch-lists/${rfsId}`}>
              BT #{rfsId}
            </Link>
          </li>
          <li>
            <Link
              to={`/punch-lists/${rfsId}/punch-list-item/${
                workOrderId
              }`}
            >
              WO #{workOrderId}
            </Link>
          </li>
          <li className='breadcrumb-siteone-li'>
            PO #{purchaseOrderId}{' '}
          </li>
        </ul>
        {!isEditPurchaseOrder
          ? this.renderPurchaseOrderInfo()
          : this.renderEditPurchaseOrder()}
        {AppSettings.clientTypeValue !== 'Homeowner' &&
          AppSettings.clientTypeValue !== 'Subcontractor' && (
            <div className='row' style={{ marginTop: 20 }}>
              <BackChargeList
                dispatch={this.props.dispatch}
                match={this.props.match}
                purchaseOrderId={purchaseOrderId}
                rfsId={rfsId}
                isPunchList={true}
              />
            </div>
          )}

        {isPreviewPDF && !isMobile && [
          <embed
            src={isPreviewPDF}
            className='pdf-preview-dialog'
            ref={ref => {
              this.embedPreview = ref;
            }}
          />,
          <i className='close-embed-preview fa fa-close' />
        ]}

        <PreviewImage
          show={show}
          imageUrl={previewUrl}
          handleClose={this.handleClose}
          isPDF={false}
        />

        {videoUrl && [
          <PreviewVideoWO
          // loading
            data={videoUrl}
            showDialog={showDialog}
            handleCloseVideo={this.handleCloseVideo}
          />
        ]}

        {/* <Modal
          show={this.state.show}
          onHide={this.handleClose}
          dialogClassName='preview-dialog'
        >
          <Modal.Header closeButton />
          <Modal.Body
            style={{ backgroundImage: `url(${this.state.previewUrl})` }}
          />
        </Modal> */}
        <iframe id='ifmcontentstoprint' style={{ height: 0, border: 'none' }} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    costCodeSelectList: state.CostCodeStore.costCodeSelectList,
    workOrderProfile: state.WorkOrderReducer.WorkOrderProfile,
    userProfile: state.UserStore.UserProfile,
    PurchaseOrderProfile: state.PurchaseOrderStore.PurchaseOrderProfile,
    WorkOrderCredentials: state.WorkOrderReducer.Credentials
  };
};

export default connect(mapStateToProps)(PurchaseOrderDetail);



// WEBPACK FOOTER //
// ./src/Punch-List/Containers/purchase-order-detail.js